import React, { useState } from 'react';
import { shape, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { copyToClipboard } from '../../utils';
import { Flex, Dialog, Button } from '../../atoms';
import { Loyalty } from '../../molecules';
import { Content, Title, Description } from './loyalty-commission-styles';
export default function CommissionBadge({
  label,
  description,
  value,
  productUrl,
  attributes: {
    color,
    icon,
    textColor
  }
}) {
  const icons = {
    coin: 'Coin',
    lightning: 'Lightning'
  };
  const iconName = icons[icon] || 'Coin';
  const [buttonActive, setButtonActive] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);

  const toggleModal = e => {
    e.stopPropagation();
    e.preventDefault();
    setModalOpen(!isModalOpen);
  };

  const onClick = link => {
    if (buttonActive) return false;
    setButtonActive(true);
    copyToClipboard(link);
    return setTimeout(() => setButtonActive(false), 3000);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loyalty, {
    hasInfo: true,
    onClick: toggleModal,
    color: color,
    icon: iconName,
    textColor: textColor,
    value: value
  }), /*#__PURE__*/React.createElement(Dialog, {
    visible: isModalOpen,
    onClickOutside: toggleModal,
    position: "center",
    showClose: true,
    type: "alert"
  }, /*#__PURE__*/React.createElement(Content, {
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    "data-testid": "loyalty-commission-icon",
    width: "25px",
    height: "25px",
    color: color
  }), /*#__PURE__*/React.createElement(Title, {
    id: "loyaltyDialogTitle",
    color: color
  }, label)), /*#__PURE__*/React.createElement(Loyalty, {
    value: value,
    color: color,
    Icon: Icon,
    textColor: textColor
  }), /*#__PURE__*/React.createElement(Description, {
    id: "loyaltyDialogDesc"
  }, description), /*#__PURE__*/React.createElement(Button, {
    rounded: true,
    variation: buttonActive ? null : 'outline',
    full: true,
    onClick: () => onClick(productUrl),
    "data-testid": "loyalty-commission-button"
  }, buttonActive ? 'Copiado' : 'Copiar Link'))));
}
process.env.NODE_ENV !== "production" ? CommissionBadge.propTypes = {
  label: string.isRequired,
  description: string.isRequired,
  value: string.isRequired,
  productUrl: string,
  attributes: shape({
    color: string,
    icon: string,
    textColor: string,
    action: string
  }).isRequired
} : void 0;